import { Typography } from "@mui/material";
import { useState, useEffect, FC } from "react";

interface ITimerForTable {
    finalAt: number; // Unix timestamp в секундах
}

export const TimerForTable: FC<ITimerForTable> = ({ finalAt }) => {
    const calculateTimeLeft = () => {
        const now = Date.now(); // Текущее время в миллисекундах
        const expiry = finalAt * 1000; // Преобразуем секунды в миллисекунды
        const timeLeft = expiry - now;

        if (timeLeft <= 0) return "00:00";

        const minutes = Math.floor((timeLeft / 1000 / 60) % 60);
        const seconds = Math.floor((timeLeft / 1000) % 60);
        return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearInterval(interval);
    }, [finalAt]);

    return <>{timeLeft}</>;
};